
  import { mapActions, mapState } from "vuex";
  import FilterDropdown from './FilterDropDown.vue'
  import Icon from './Icon'
  
  export default {
    name: 'DietaryFilters',
    components: {
      FilterDropdown,
      Icon
    },
    data() {
      return {
        dietaryFilters: [],
        lifeStyleFilters: [],
        showFilters: false,
        localDietaryConfig: [],
        localLifeStyleConfig: [],
      };
    },
    props: {
      dietaryConfig: {
        type: Array,
      },
      lifeStyleConfig: {
        type: Array,
      },
    },
    mounted() {
      this.initializeFilters();
  
      if (this.$route.query.dietaryFilters) {
        this.dietaryFilters = this.$route.query.dietaryFilters
          ? this.$route.query.dietaryFilters.split(",")
          : [];
      }
      if (this.$route.query.lifeStyleFilters) {
        this.lifeStyleFilters = this.$route.query.lifeStyleFilters
          ? this.$route.query.lifeStyleFilters.split(",")
          : [];
      }
  
      this.localDietaryConfig = this.dietaryConfig?.map((f) => {
        f.toggled = this.dietaryFilters.includes(f.name);
        return f;
      });
  
      this.localLifeStyleConfig = this.lifeStyleConfig?.map((f) => {
        f.toggled = this.lifeStyleFilters.includes(f.name);
        return f;
      });
    },
    computed: {
      ...mapState(["menu"]),
    },
    methods: {
      ...mapActions(["filterMenu"]),
      initializeFilters() {
        this.localDietaryConfig = this.dietaryConfig ? [...this.dietaryConfig] : [];
        this.localLifeStyleConfig = this.lifeStyleConfig ? [...this.lifeStyleConfig] : [];
      },
      addDietaryFilter(filter) {
        if (!this.dietaryFilters.includes(filter.name)) {
          this.dietaryFilters.push(filter.name);
        }
        this.localDietaryConfig.find((f) => f.name === filter.name).toggled = true;
        this.updateQueryParams();
        this.$emit('filter-dietary', this.dietaryFilters);
      },
      removeAllFilters() {
        this.dietaryFilters = [];
        this.lifeStyleFilters = [];
        this.localDietaryConfig.forEach((f) => (f.toggled = false));
        this.localLifeStyleConfig.forEach((f) => (f.toggled = false));
        this.updateQueryParams();
        this.$emit('filter-dietary', this.dietaryFilters);
        this.$emit('filter-lifestyle', this.lifeStyleFilters);
      },
      removeDietaryFilter(filter) {
        this.dietaryFilters = this.dietaryFilters.filter(
          (f) => f !== filter.name
        );
        this.localDietaryConfig.find((f) => f.name === filter.name).toggled = false;
        this.updateQueryParams();
        this.$emit('filter-dietary', this.dietaryFilters);
      },
      addLifeStyleFilter(filter) {
        if (!this.lifeStyleFilters.includes(filter.name)) {
          this.lifeStyleFilters.push(filter.name);
        }
        this.localLifeStyleConfig.find((f) => f.name === filter.name).toggled = true;
        this.updateQueryParams();
        this.$emit('filter-lifestyle', this.lifeStyleFilters);
      },
      removeLifeStyleFilter(filter) {
        this.lifeStyleFilters = this.lifeStyleFilters.filter(
          (f) => f !== filter.name
        );
        this.localLifeStyleConfig.find((f) => f.name === filter.name).toggled = false;
        this.updateQueryParams();
        this.$emit('filter-lifestyle', this.lifeStyleFilters);
      },
      updateQueryParams() {
        const query = {};
        if (this.dietaryFilters.length > 0) {
          query.dietaryFilters = this.dietaryFilters.join(",");
        }
        if (this.lifeStyleFilters.length > 0) {
          query.lifeStyleFilters = this.lifeStyleFilters.join(",");
        }
        this.$router.push({ query });
      },
    },
    watch: {
      $route(to, from) {
        this.dietaryFilters = this.$route.query?.dietaryFilters
          ? this.$route.query.dietaryFilters.split(",")
          : [];
        this.lifeStyleFilters = this.$route.query?.lifeStyleFilters
          ? this.$route.query.lifeStyleFilters.split(",")
          : [];
  
        this.localDietaryConfig = this.dietaryConfig.map((f) => {
          f.toggled = this.dietaryFilters.includes(f.name);
          return f;
        });
        this.localLifeStyleConfig = this.lifeStyleConfig.map((f) => {
          f.toggled = this.lifeStyleFilters.includes(f.name);
          return f;
        });
        this.$emit('filter-dietary', this.dietaryFilters);
        this.$emit('filter-lifestyle', this.lifeStyleFilters);
      },
      dietaryConfig: {
        handler(newValue) {
          this.localDietaryConfig = [...newValue];
        },
        deep: true
      },
      lifeStyleConfig: {
        handler(newValue) {
          this.localLifeStyleConfig = [...newValue];
        },
        deep: true
      }
    },
  };
  